import { Typography } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { ColdHandoffStatus } from 'features/cold-handoff/enums';
import { useColdHandoffAcceptedRnsHandlers } from 'features/cold-handoff/hooks';
import {
  coldHandoffStatusSelector,
  confirmColdHandoffTransfer,
} from 'features/cold-handoff/store';
import { CollaborationStepContainer } from 'features/collaboration-base/components';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Button } from 'features/ui/elements';

export const ColdHandoffAccepted = () => {
  const { t: ct } = useTranslation();
  const dispatch = useAppDispatch();
  const status = useAppSelector(coldHandoffStatusSelector);
  useColdHandoffAcceptedRnsHandlers();

  const handleConfirmRequest = useCallback(() => {
    dispatch(confirmColdHandoffTransfer());
  }, [dispatch]);

  return (
    <>
      {status === ColdHandoffStatus.ACCEPTED && (
        <CollaborationStepContainer testId='cold-handoff-accepted'>
          <Typography variant='body1' color={theme.palette.grey[50]}>
            {ct('availableVi')}
          </Typography>
          <Typography
            variant='body2'
            color={theme.palette.common.white}
            mt={8}
            lineHeight='24px'
          >
            {ct('handoffCallDescription')}
          </Typography>
          <ConfirmButton
            size='small'
            color='primary'
            title={ct('handoffCall')}
            onClick={handleConfirmRequest}
            autoFocus
          >
            {ct('handoffCall')}
          </ConfirmButton>
        </CollaborationStepContainer>
      )}
    </>
  );
};

const ConfirmButton = styled(Button)`
  margin-top: ${theme.spacing(8)};
`;
